import React from 'react';
import {
    sendPasswordResetEmail} from "firebase/auth";
import {auth} from "../firebase-config";

const Forgot = () => {
    const sendUsersReset = () => {
        var email = document.getElementById("email").value;
        sendPasswordResetEmail(auth,email).then((res) => {
            alert("Email sent.");
        });
    }
    return (
        <div className="auth-wrapper">
          <div className="auth-inner">
                <h3>Forgot Password</h3>
                <div className="mb-3">
                <label>Email address</label>
                <input
                    type="email"
                    id="email"
                    className="form-control"
                    placeholder="Enter email"
                />
                We will send one email address to restart password if email account is associated to an account.
                </div>

                <div className="d-grid">
                <button type="submit" onClick={sendUsersReset} className="btn btn-primary">
                    Submit
                </button>
                </div>
        </div>
      </div>
    )
}

export default Forgot;